import React from 'react';

const BlockIdDarkIcon = ({height="43", width="42"}) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 43" fill="none">
      <rect opacity="0.3" y="0.5" width="42" height="42" rx="10" fill="white" fillOpacity="0.4"/>
      <mask id="mask0_700_4796" style={{'maskType':'alpha'}} maskUnits="userSpaceOnUse" x="11" y="11" width="20" height="21">
        <rect x="11" y="11.5" width="20" height="20" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_700_4796)">
        <path d="M20.1667 27.6873V21.979L15.1667 19.0832V24.7915L20.1667 27.6873ZM21.8333 27.6873L26.8333 24.7915V19.0832L21.8333 21.979V27.6873ZM21 20.5415L25.9375 17.6873L21 14.8332L16.0625 17.6873L21 20.5415ZM14.3333 26.2498C14.0694 26.0971 13.8646 25.8957 13.7188 25.6457C13.5729 25.3957 13.5 25.1179 13.5 24.8123V18.1873C13.5 17.8818 13.5729 17.604 13.7188 17.354C13.8646 17.104 14.0694 16.9026 14.3333 16.7498L20.1667 13.3957C20.4306 13.2429 20.7083 13.1665 21 13.1665C21.2917 13.1665 21.5694 13.2429 21.8333 13.3957L27.6667 16.7498C27.9306 16.9026 28.1354 17.104 28.2813 17.354C28.4271 17.604 28.5 17.8818 28.5 18.1873V24.8123C28.5 25.1179 28.4271 25.3957 28.2813 25.6457C28.1354 25.8957 27.9306 26.0971 27.6667 26.2498L21.8333 29.604C21.5694 29.7568 21.2917 29.8332 21 29.8332C20.7083 29.8332 20.4306 29.7568 20.1667 29.604L14.3333 26.2498Z" fill="url(#paint0_linear_700_4796)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_700_4796" x1="21" y1="13.1665" x2="21" y2="29.8332" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF5F14"/>
          <stop offset="1" stopColor="#E88947"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BlockIdDarkIcon;
